import { jsxs, jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import Typography from "../Typography/Typography.js";
import classnames from "../../utils/classnames.js";
const DealerInfoContacts = ({
  label,
  phones,
  emails,
  className,
  onPhoneClick,
  onEmailClick,
  mode = "row"
}) => {
  const handlePhoneClick = useCallback(
    (e) => {
      var _a, _b;
      const phone = (_b = (_a = e == null ? void 0 : e.currentTarget) == null ? void 0 : _a.dataset) == null ? void 0 : _b.phone;
      if (phone) {
        onPhoneClick == null ? void 0 : onPhoneClick(phone);
      }
    },
    [onPhoneClick]
  );
  const handleEmailClick = useCallback(
    (e) => {
      var _a, _b;
      const email = (_b = (_a = e == null ? void 0 : e.currentTarget) == null ? void 0 : _a.dataset) == null ? void 0 : _b.email;
      if (email) {
        onEmailClick == null ? void 0 : onEmailClick(email);
      }
    },
    [onEmailClick]
  );
  if (!(phones == null ? void 0 : phones.length) && !(emails == null ? void 0 : emails.length)) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-dealer-info-contacts", className), children: [
    /* @__PURE__ */ jsxs(Typography.Text, { level: "small", color: "dark-light", className: classnames("perxis-auto-dealer-info-contacts__label"), children: [
      label,
      ":"
    ] }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classnames([
          "perxis-auto-dealer-info-contacts__container",
          `perxis-auto-dealer-info-contacts__container--${mode}`
        ]),
        children: [
          phones == null ? void 0 : phones.map((phone, i) => /* @__PURE__ */ jsx(
            Typography.Link,
            {
              href: `tel:${phone}`,
              level: "small",
              color: "darkest",
              "data-phone": phone,
              onClick: handlePhoneClick,
              className: classnames("perxis-auto-dealer-info-contacts__value"),
              children: phone
            },
            i
          )),
          emails == null ? void 0 : emails.map((email, i) => /* @__PURE__ */ jsx(
            Typography.Link,
            {
              href: `mailto:${email}`,
              level: "small",
              color: "darkest",
              "data-email": email,
              onClick: handleEmailClick,
              className: classnames("perxis-auto-dealer-info-contacts__value"),
              children: email
            },
            i
          ))
        ]
      }
    )
  ] });
};
export {
  DealerInfoContacts as default
};
//# sourceMappingURL=DealerInfoContacts.js.map
